import { shouldNeverHappen } from '../../utils/shouldBeverHappen';

const TEXT_RU = {
  label: 'Поиск',
  placeholder: 'Введите ваш запрос',
  buttonLabel: 'Найти',
  deleteFromHistory: 'Удалить из истории',
  toSearchResults: 'Перейти к результатам поиска',
  enableHistory: 'Запоминать историю поиска',
  disableHistory: 'Не запоминать историю поиска',
};

type Translation = typeof TEXT_RU;

const TEXT_EN: Translation = {
  label: 'Search',
  placeholder: 'Search by keyword',
  buttonLabel: 'Search',
  deleteFromHistory: 'Delete from history',
  toSearchResults: 'To search results',
  enableHistory: 'Remember search history',
  disableHistory: 'Do not remember search history',
};

export const supportedLanguages = { ru: 'ru', en: 'en' };

export function createLanguageGetter(
  activeLanguage: keyof typeof supportedLanguages = 'ru'
) {
  return function getText(id: keyof Translation) {
    switch (activeLanguage) {
      case 'ru':
        return TEXT_RU[id];
      case 'en':
        return TEXT_EN[id];
      default:
        shouldNeverHappen(activeLanguage);
        return '';
    }
  };
}
